import { useState } from 'react';
import apiService from '../../axios/apiService';

export const useRadiologistInvoiceList = () => {
  const [data, setData] = useState();
  const getList = async (params) => {
    // Fetch data
    const list = await apiService.getRadiologistInvoiceList(params);
    list && setData(list); // update data state
    return list;
  };

  return {
    data,
    getList,
  };
};
